import { forwardRef } from 'react';
import { ButtonColor, ButtonVariant, getButtonStyles, ButtonSize, getLoadingSpinnerStyles } from '../../../utils/buttonStyles.js';
import { getLinkStyles } from './LinkStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { SpinnerSize } from '../../../components/Spinner/SpinnerStyles.js';
import { Spinner } from '../../../components/Spinner/Spinner.js';

const Link = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _buttonProps$isLoadin, _buttonProps$color, _buttonProps$variant, _buttonProps$isDisabl, _buttonProps$size, _buttonProps$isInacti, _buttonProps$isFullWi, _buttonProps$spinner;
  let {
    isButton = false,
    rel: externalRel = '',
    isExternal = false,
    bold = true,
    href,
    linkProps,
    buttonProps,
    children,
    ...rest
  } = _ref;
  const buttonIsLoading = (_buttonProps$isLoadin = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.isLoading) !== null && _buttonProps$isLoadin !== void 0 ? _buttonProps$isLoadin : false;
  const buttonColor = (_buttonProps$color = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.color) !== null && _buttonProps$color !== void 0 ? _buttonProps$color : ButtonColor.PRIMARY;
  const buttonVariant = (_buttonProps$variant = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.variant) !== null && _buttonProps$variant !== void 0 ? _buttonProps$variant : ButtonVariant.FILLED;
  const css = isButton ? getButtonStyles({
    bold,
    color: buttonColor,
    variant: buttonVariant,
    isLoading: buttonIsLoading,
    disabled: (_buttonProps$isDisabl = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.isDisabled) !== null && _buttonProps$isDisabl !== void 0 ? _buttonProps$isDisabl : false,
    size: (_buttonProps$size = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.size) !== null && _buttonProps$size !== void 0 ? _buttonProps$size : ButtonSize.MEDIUM,
    isInactive: (_buttonProps$isInacti = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.isInactive) !== null && _buttonProps$isInacti !== void 0 ? _buttonProps$isInacti : false,
    isFullWidth: (_buttonProps$isFullWi = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.isFullWidth) !== null && _buttonProps$isFullWi !== void 0 ? _buttonProps$isFullWi : false
  }) : getLinkStyles({
    bold,
    dark: linkProps === null || linkProps === void 0 ? void 0 : linkProps.isDark
  });
  return jsxs("a", {
    css: css,
    ref: ref,
    href: href,
    rel: isExternal ? `${externalRel} noopener noreferrer nofollow` : externalRel,
    ...rest,
    children: [children, isButton && buttonIsLoading && jsx("span", {
      css: getLoadingSpinnerStyles(buttonColor, buttonVariant),
      children: (_buttonProps$spinner = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.spinner) !== null && _buttonProps$spinner !== void 0 ? _buttonProps$spinner : jsx(Spinner, {
        size: SpinnerSize.SIZE_SMALL
      })
    })]
  });
});
Link.displayName = 'Link';

export { Link };
//# sourceMappingURL=Link.js.map
